/* Bull Ring Fabrics — head scripts, part 2 of 4 (2026-10-31, Abid). Scripts that used to be printed inline into the <head> of every
   page by the snippets named below (rendered from snippets/brf-local-business-schema). Moved into cached files. Loaded without defer,
   in order, at the same point in the head, so they run exactly when they used to. Each block is marked with the snippet it came from. */

/* ===== from snippets/brf-load-calm.liquid ===== */
/* 2026-10-28 12:42 (Abid): press and hold − or + (product page box, quick view, Add to bag bar) and the length keeps
   changing, speeding up the longer it's held. Each step is a normal click on the button, so stock caps and the bar's
   own rules still apply; it stops when the number stops changing (cap reached). After someone taps + three times in
   a row, a small tip bubble explains it, shown once per browser (localStorage brf-hold-tip). Not in the bag drawer. */
(function(){
  if (window.__brfHold) return; window.__brfHold = 1;
  var doc = document, SEL = 'quantity-picker .quantity-selector__button, .brf-sab__step';
  var h = null, swallowUntil = 0, synth = false, taps = 0, tapT = 0;
  function valOf(b){ var w = b.closest('quantity-picker, [data-brf-sab-qty], .brf-sab__q') || b.parentNode, i = w && w.querySelector('input'); return i ? i.value : ''; }
  function fire(b){ synth = true; try { b.click(); } finally { synth = false; } }
  function step(){
    if (!h) return;
    var before = valOf(h.b); fire(h.b); h.n++;
    if (valOf(h.b) === before) { stop(); return; }
    var t = Date.now() - h.t0, gap = t > 2500 ? 40 : t > 1200 ? 80 : 160;
    h.timer = setTimeout(step, gap);
  }
  function stop(){ if (!h) return; clearTimeout(h.timer); h.b.classList.remove('brf-hold-on'); if (h.n) { swallowUntil = Date.now() + 500; try { localStorage.setItem('brf-hold-tip', '1'); } catch (e) {} } h = null; }
  doc.addEventListener('pointerdown', function(e){
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    var b = e.target.closest && e.target.closest(SEL); if (!b || b.disabled || b.closest('#mini-cart')) return;
    stop();
    h = {b: b, n: 0, t0: Date.now() + 450};
    h.timer = setTimeout(function(){ if (!h) return; h.t0 = Date.now(); h.b.classList.add('brf-hold-on'); fire(h.b); h.n = 1; h.timer = setTimeout(step, 160); }, 450);
  }, true);
  ['pointerup', 'pointercancel', 'pointerleave', 'blur'].forEach(function(ev){ (ev === 'blur' ? window : doc).addEventListener(ev, function(e){ if (ev === 'pointerleave' && h && e.target !== h.b) return; stop(); }, true); });
  doc.addEventListener('contextmenu', function(e){ if (e.target.closest && e.target.closest(SEL)) e.preventDefault(); }, true);
  /* the real click that follows a hold must not add one more */
  doc.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest(SEL); if (!b || synth) return;
    if (Date.now() < swallowUntil) { e.stopImmediatePropagation(); e.preventDefault(); swallowUntil = 0; return; }
    /* three quick taps on + : show the tip once */
    var plus = /increase|plus|\+/i.test((b.getAttribute('aria-label') || '') + (b.getAttribute('data-action') || '') + (b.getAttribute('data-d') === '1' ? '+' : '') + b.textContent);
    if (!plus) { taps = 0; return; }
    taps = Date.now() - tapT < 1500 ? taps + 1 : 1; tapT = Date.now();
    if (taps >= 3) { taps = 0; tip(b); }
  }, true);
  function tip(b){
    if (window.__brfTipShown) return;
    try { if (localStorage.getItem('brf-hold-tip')) return; localStorage.setItem('brf-hold-tip', '1'); } catch (e) { return; }
    var r = b.getBoundingClientRect(), el = doc.createElement('div');
    window.__brfTipShown = 1; el.className = 'brf-hold-tip'; el.setAttribute('role', 'status');
    el.innerHTML = '<b>Tip:</b> press and hold + (or −) to change the length faster.';
    doc.body.appendChild(el);
    var w = el.offsetWidth, left = Math.max(12, Math.min(innerWidth - w - 12, r.right - w + 8));
    el.style.left = left + 'px'; el.style.top = Math.max(8, r.top - el.offsetHeight - 10) + 'px';
    el.style.setProperty('--brf-tip-x', Math.max(10, Math.min(w - 20, r.left + r.width / 2 - left - 5)) + 'px');
    requestAnimationFrame(function(){ el.classList.add('is-in'); });
    var gone = function(){ el.classList.remove('is-in'); setTimeout(function(){ if (el.parentNode) el.parentNode.removeChild(el); }, 300); window.removeEventListener('scroll', gone, true); };
    var born = window.brfTipLife(el, gone); window.addEventListener('scroll', function sc(){ if (Date.now() - born > 3000) { window.removeEventListener('scroll', sc, true); gone(); } }, true);
  }
  /* hover text on the theme's buttons */
  function titles(){ [].forEach.call(doc.querySelectorAll('quantity-picker .quantity-selector__button, .brf-sab__step'), function(b){ var d = b.getAttribute('data-d'), t = b.getAttribute('title') || b.getAttribute('aria-label') || (d ? (+d > 0 ? 'Increase' : 'Decrease') + ' quantity' : ''); if (t && !/hold/i.test(t)) b.setAttribute('title', t.replace(/\s*by 1$/i, '') + ' (press and hold to go faster)'); }); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', titles); else titles();
  window.addEventListener('load', titles);
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* 2026-10-28 13:00 (Abid): small one-off tip bubbles where shoppers (often older) can get stuck: product photos,
   colours, voice search, card colour picker, collection filters, and a clearer "Saved" message on the first wishlist save.
   Rules: never on page load, only after someone lingers on the thing (or uses it nearby); one bubble per page view;
   each tip once per browser (localStorage brf-tips); never while the cookie banner, chat, bag, colour sheet or a
   toast is open; gone after 4.5s or on scroll. Doing the thing yourself counts as "seen". */
(function(){
  if (window.__brfTips) return; window.__brfTips = 1;
  var doc = document, seen = {};
  try { seen = JSON.parse(localStorage.getItem('brf-tips') || '{}') || {}; } catch (e) { return; }
  function mark(id){ seen[id] = 1; try { localStorage.setItem('brf-tips', JSON.stringify(seen)); } catch (e) {} }
  var phone = matchMedia('(max-width: 749px)').matches, touch = matchMedia('(hover: none)').matches;
  function vis(el){ if (!el) return false; var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; }
  function busy(){
    var h = doc.documentElement, c = doc.querySelector('shopify-chat'), mc = doc.querySelector('.mini-cart');
    return window.__brfTipShown || h.classList.contains('brf-consent-open') || vis(doc.getElementById('shopify-pc__banner')) ||
      (c && c.open) || (mc && mc.getAttribute('aria-hidden') === 'false') ||
      doc.querySelector('.brf-sab-sheet.is-open, .brf-sab-sheet[aria-hidden="false"], .brf-wl-toast.is-in, .brf-addt.is-on, .brf-hold-tip, .brf-tip');
  }
  function floor(){
    var b = innerHeight, bar = doc.querySelector('.brf-sticky-atc');
    if (bar) { var r = bar.getBoundingClientRect(); if (r.height && r.top < innerHeight && r.bottom > 0) b = Math.min(b, r.top); }
    return b - 8;
  }
  function show(t, el){
    if (seen[t.id] || busy()) return false;
    var r = el.getBoundingClientRect(); if (!r.width || r.bottom < 0 || r.top > innerHeight) return false;
    window.__brfTipShown = 1; mark(t.id);
    var tip = doc.createElement('div'); tip.className = 'brf-tip'; tip.setAttribute('role', 'status');
    tip.innerHTML = '<b>Tip:</b> ' + t.text; doc.body.appendChild(tip);
    var w = tip.offsetWidth, hgt = tip.offsetHeight, bot = floor(), pos, top, left;
    if (t.over) { pos = 'over'; left = r.left + r.width / 2 - w / 2; top = Math.min(r.bottom, bot) - hgt - 16; }
    else {
      left = r.left + r.width / 2 - w / 2;
      pos = r.top - hgt - 12 >= 8 ? 'above' : 'below';
      top = pos === 'above' ? r.top - hgt - 10 : r.bottom + 10;
      if (top + hgt > bot) { pos = 'above'; top = Math.max(8, r.top - hgt - 10); }
    }
    left = Math.max(12, Math.min(innerWidth - w - 12, left));
    /* keep clear of the chat button corner */
    if (left + w > innerWidth - 80 && top + hgt > bot - 80) top = bot - 80 - hgt;
    tip.setAttribute('data-pos', pos); tip.style.left = left + 'px'; tip.style.top = Math.max(8, top) + 'px';
    tip.style.setProperty('--brf-tip-x', Math.max(12, Math.min(w - 22, r.left + r.width / 2 - left - 5)) + 'px');
    requestAnimationFrame(function(){ tip.classList.add('is-in'); });
    var gone = function(){ tip.classList.remove('is-in'); setTimeout(function(){ if (tip.parentNode) tip.parentNode.removeChild(tip); }, 300); removeEventListener('scroll', gone, true); };
    window.brfTipLife(tip, gone); setTimeout(function(){ addEventListener('scroll', gone, true); }, 3000);
    return true;
  }
  /* "linger" tips: the thing sits mostly in view for a while, untouched */
  var TIPS = [
    {id: 'gallery', sel: '.product-gallery', over: 1, wait: 2000, need: function(){ return doc.querySelectorAll('.product-gallery__media, .product-gallery__carousel-item').length > 1; },
      text: touch ? 'Swipe for more photos · tap to zoom' : 'Use the arrows for more photos',
      done: '.brf-garrow, .product-gallery__thumbnail, .product-gallery__carousel'},
    {id: 'colours', sel: 'button.brf-vp__current', wait: 2000, need: function(){ return /browse all/i.test((doc.querySelector('button.brf-vp__current') || {}).textContent || ''); },
      text: 'Tap a colour to see it — Browse all shows every shade', done: '.brf-vp, .product-form__option-selector, variant-picker'},
    {id: 'cardpick', sel: '.product-item .brf-ucard__pick', wait: 3000, need: function(){ return !doc.querySelector('.product-gallery'); },
      text: 'Pick a colour, then add straight to your bag', done: '.brf-ucard__select, .brf-ucard__pick'},
    {id: 'filters', sel: '.brf-fstick', wait: 2500, need: function(){ return seen.cardpick && scrollY > 700; },
      text: 'Tap a filter to narrow by colour, type or price', done: '.brf-fstick'}
  ];
  function arm(t){
    if (seen[t.id]) return;
    var els = [].slice.call(doc.querySelectorAll(t.sel)); if (!els.length || (t.need && !t.need())) return;
    if (t.armed) return; t.armed = 1;
    doc.addEventListener('pointerdown', function(e){ if (e.target.closest && e.target.closest(t.done)) mark(t.id); }, true);
    doc.addEventListener('change', function(e){ if (e.target.closest && e.target.closest(t.done)) mark(t.id); }, true);
    if (t.id === 'gallery') { var car = doc.querySelector('.product-gallery__carousel'); if (car) car.addEventListener('scroll', function(){ if (!window.__brfTipShown) mark('gallery'); }, {passive: true}); }
    var timer = null, io = new IntersectionObserver(function(list){
      list.forEach(function(en){
        if (en.isIntersecting && en.intersectionRatio >= .6) {
          clearTimeout(timer);
          timer = setTimeout(function(){ if (seen[t.id] || (t.need && !t.need())) return; if (show(t, en.target)) io.disconnect(); }, t.wait);
        } else if (timer && en.target === timer.el) clearTimeout(timer);
        else if (!en.isIntersecting) clearTimeout(timer);
      });
    }, {threshold: [0, .6]});
    els.slice(0, 1).forEach(function(el){ io.observe(el); });
  }
  function armAll(){ TIPS.forEach(arm); }
  /* voice search: the search box is focused but nothing's typed for 3s */
  var micT = null;
  doc.addEventListener('focusin', function(e){
    if (seen.mic || !e.target.matches || !e.target.matches('input.search-bar__input, input[type="search"]')) return;
    var inp = e.target; clearTimeout(micT);
    micT = setTimeout(function(){ var m = doc.querySelector('button.brf-mic'); if (!inp.value && doc.activeElement === inp && vis(m)) show({id: 'mic', text: 'Tap the mic to search by voice'}, m); }, 3000);
  }, true);
  doc.addEventListener('input', function(e){ if (e.target.matches && e.target.matches('input.search-bar__input, input[type="search"]')) clearTimeout(micT); }, true);
  doc.addEventListener('pointerdown', function(e){ if (e.target.closest && e.target.closest('button.brf-mic')) { clearTimeout(micT); mark('mic'); } }, true);
  /* first wishlist save: say where saved things live */
  if (!seen.wlsave) new MutationObserver(function(ms, mo){
    var s = doc.querySelector('.brf-wl-toast span'); if (!s || seen.wlsave) { if (seen.wlsave) mo.disconnect(); return; }
    if (/^Saved to your wishlist$/.test(s.textContent)) { s.textContent = 'Saved! Find it any time under ♡ at the top'; mark('wlsave'); mo.disconnect(); }
  }).observe(doc.documentElement, {childList: true, subtree: true, characterData: true});
  if (!('IntersectionObserver' in window)) return;
  if (doc.readyState === 'complete') setTimeout(armAll, 1500); else addEventListener('load', function(){ setTimeout(armAll, 1500); });
  var n = 0, iv = setInterval(function(){ armAll(); if (++n > 20) clearInterval(iv); }, 1500);
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* 12:48 (Abid): desktop header bag: free delivery progress straight under the bag's header, before the items.
   brf-c-header.js rebuilds the panel from /cart.js, so move it back up each time it's redrawn. */
(function(){
  if (window.__brfFreeTop) return; window.__brfFreeTop = 1;
  function fix(){
    var bag = document.getElementById('brf-hc-bag'); if (!bag) return;
    var f = bag.querySelector(':scope > .brf-hc__bag-free'), h = bag.querySelector(':scope > .brf-hc__bag-h');
    if (f && h && h.nextElementSibling !== f) h.parentNode.insertBefore(f, h.nextSibling);
  }
  new MutationObserver(fix).observe(document.documentElement, {childList: true, subtree: true});
  fix();
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* 13:02 (Abid): bag page "Complete your cart": products already in the bag stay (sections/brf-cart.liquid) so more colours
   can be added; tag those cards "In your bag". Redrawn after every bag change. */
(function(){
  if (window.__brfInBag) return; window.__brfInBag = 1;
  function go(){
  if (!document.body.classList.contains('template-cart')) return;
  var ids = {}, t = 0;
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  function paint(){
    [].forEach.call(document.querySelectorAll('[data-section-id$="-upsell"] .product-item'), function(c){
      var i = c.querySelector('input[name="product-id"]'), on = !!(i && ids[i.value]), tag = c.querySelector(':scope > .brf-inbag');
      c.classList.toggle('brf-inbag-on', on);
      if (on && !tag) { tag = document.createElement('span'); tag.className = 'brf-inbag'; tag.innerHTML = TICK + 'In your bag'; c.appendChild(tag); }
      else if (!on && tag) tag.remove();
    });
  }
  function load(){
    fetch('/cart.js', {credentials: 'same-origin'}).then(function(r){ return r.json(); }).then(function(c){
      ids = {}; (c.items || []).forEach(function(it){ ids[it.product_id] = 1; }); paint();
    }).catch(function(){});
  }
  function soon(){ clearTimeout(t); t = setTimeout(load, 300); }
  document.addEventListener('cart:rerendered', soon, true);
  document.addEventListener('product:added', soon, true);
  load();
  new MutationObserver(function(){ paint(); }).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* 14:28 (Abid): let shoppers zoom further into the weave in the photo viewer (Warehouse caps it at about 1.3x).
   Only works when PhotoSwipe is a global; otherwise the theme's own settings stay. */
(function(){
  function wrap(){
    var P = window.PhotoSwipe; if (!P || P.__brf) return !!P;
    var W = function(el, ui, items, opts){
      opts = opts || {};
      opts.maxSpreadZoom = Math.max(opts.maxSpreadZoom || 0, 3);
      opts.getDoubleTapZoom = function(isMouse, item){ return item.initialZoomLevel < 0.7 ? 1 : 2.5; };
      return new P(el, ui, items, opts);
    };
    W.prototype = P.prototype; W.__brf = 1; for (var k in P) if (Object.prototype.hasOwnProperty.call(P, k)) W[k] = P[k];
    window.PhotoSwipe = W; return true;
  }
  if (!wrap()) { var n = 0, iv = setInterval(function(){ if (wrap() || ++n > 40) clearInterval(iv); }, 500); }
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-28 (Abid): keep the colour strip steady while the theme swaps the variant block (no raw grid flash) */
(function(){
  if (window.__brfVpKeep) return; window.__brfVpKeep = 1;
  var doc = document, ghost = null;
  doc.addEventListener('click', function(e){
    var m = e.target.closest && e.target.closest('.product-block-list__item--info .brf-vp__mini[data-v]');
    if (!m) return;
    var vp = m.closest('.brf-vp'); if (!vp) return;
    ghost = vp.cloneNode(true); ghost.classList.add('brf-vp--ghost'); ghost.setAttribute('aria-hidden', 'true');
    [].forEach.call(ghost.querySelectorAll('.brf-vp__mini'), function(b){ b.classList.toggle('is-on', b.getAttribute('data-v') === m.getAttribute('data-v')); });
    var b = ghost.querySelector('.brf-vp__meta b'); if (b) b.textContent = m.getAttribute('data-v');
    var ti = ghost.querySelector('.brf-vp__thumb img'), mi = m.querySelector('img');
    if (ti && mi) { ti.removeAttribute('srcset'); ti.src = mi.currentSrc || mi.src; }
  }, true);
  function patch(){
    var opts = doc.querySelectorAll('.product-block-list__item--info .product-form__option');
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i], real = o.querySelector('.brf-vp:not(.brf-vp--ghost)'), g = o.querySelector('.brf-vp--ghost');
      if (real && g) g.remove();
      else if (!real && !g && ghost && o.querySelector('.variant-swatch-list, .color-swatch-list, .block-swatch-list')) o.appendChild(ghost.cloneNode(true));
    }
  }
  function boot(){ new MutationObserver(patch).observe(doc.querySelector('.product-block-list__item--info') || doc.body, {childList: true, subtree: true}); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-28 (Abid): Rewards pill in the product share row (opens Smile); Google badge back in the corner now the floating Rewards button is gone */
(function(){
  if (window.__brfPdpRewards) return; window.__brfPdpRewards = 1;
  var doc = document;
  /* sitewide: the Google badge was lifted above the Rewards launcher with an inline bottom:110px !important; put it back in the corner */
  var watched = null, bo = new MutationObserver(badge);
  function badge(){
    var g = doc.getElementById('google-merchantwidget-iframe-wrapper'); if (!g) return;
    if (g.style.getPropertyValue('bottom') !== '20px') g.style.setProperty('bottom', '20px', 'important');
    if (watched !== g) { watched = g; bo.observe(g, {attributes: true, attributeFilter: ['style']}); }
  }
  function go(){
    badge(); new MutationObserver(function(){ if (!watched || !watched.isConnected) badge(); }).observe(doc.body, {childList: true});
    if (!doc.body.classList.contains('template-product')) return;
    var ICON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18M12 8c-2.5 0-4.5-1-4.5-2.75S9.5 3 12 8zm0 0c2.5 0 4.5-1 4.5-2.75S14.5 3 12 8z"/></svg>';
    function openSmile(){
      try { if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') { window.SmileUI.openPanel(); return; } } catch (e) {}
      var f = doc.getElementById('smile-lite-launcher-frame') || doc.querySelector('#smile-ui-lite-launcher-frame-container iframe');
      try { var d = f && (f.contentDocument || f.contentWindow.document); var b = d && d.querySelector('button, [role="button"], a'); if (b) { b.click(); return; } } catch (e) {}
      var c = doc.getElementById('smile-ui-lite-launcher-frame-container'); if (c) c.click();
    }
    function add(){
      [].forEach.call(doc.querySelectorAll('.product-block-list__item--info .product-meta__share-buttons .social-media__item-list'), function(list){
        if (list.querySelector('.brf-rw-pill')) return;
        var li = doc.createElement('li'); li.className = 'social-media__item brf-rw-li';
        li.innerHTML = '<button type="button" class="brf-rw-pill" aria-label="Open Rewards">' + ICON + '<span>Rewards</span></button>';
        li.firstChild.addEventListener('click', function(e){ e.preventDefault(); openSmile(); });
        list.appendChild(li);
      });
    }
    add(); new MutationObserver(add).observe(doc.querySelector('.product-block-list__item--info') || doc.body, {childList: true, subtree: true});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-28 (Abid): tag per-metre sale price rows on cards so CSS can show "£1.99m | Was £3.99m" */
(function(){
  if (window.__brfPmSale) return; window.__brfPmSale = 1;
  var doc = document, t = 0;
  function tag(){
    var l = doc.querySelectorAll('.product-item .product-item__price-list:not([data-brf-pm])');
    for (var i = 0; i < l.length; i++) {
      var u = l[i].querySelector('.brf-unit'), on = !!(u && l[i].querySelector('.price--compare') && /^per metre$/i.test(u.textContent.trim()));
      l[i].setAttribute('data-brf-pm', on ? '1' : '0');
    }
  }
  function go(){ tag(); new MutationObserver(function(){ clearTimeout(t); t = setTimeout(tag, 30); }).observe(doc.body, {childList: true, subtree: true}); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-28 (Abid): per-metre sale rows: stack "Was £3.99/m" on its own line only when it doesn't fit beside the price */
(function(){
  if (window.__brfPmFit) return; window.__brfPmFit = 1;
  var doc = document, t = 0, w = 0;
  function fit(){
    var l = doc.querySelectorAll('.product-item .product-item__price-list[data-brf-pm="1"]'), i, a, c, wrap = [];
    for (i = 0; i < l.length; i++) l[i].classList.remove('brf-pm-2');
    for (i = 0; i < l.length; i++) {
      a = l[i].querySelector('.price:not(.price--compare)'); c = l[i].querySelector('.price--compare');
      if (a && c && c.getBoundingClientRect().top >= a.getBoundingClientRect().bottom - 1) wrap.push(l[i]);
    }
    for (i = 0; i < wrap.length; i++) wrap[i].classList.add('brf-pm-2');
  }
  function later(){ clearTimeout(t); t = setTimeout(fit, 60); }
  function go(){
    fit();
    new MutationObserver(function(ms){
      for (var i = 0; i < ms.length; i++) if (ms[i].attributeName === 'data-brf-pm' || ms[i].addedNodes.length) return later();
    }).observe(doc.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-brf-pm']});
    window.addEventListener('resize', function(){ if (window.innerWidth !== w) { w = window.innerWidth; later(); } });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(later);
  }
  w = window.innerWidth;
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* 2026-10-29 (Abid): on product cards, asking for more than we have (tapping + at the limit, or typing a bigger number)
   gives the qty box a little shake and a soft bubble in plain words: how many are left, and what's already in the bag. */
(function(){
  if (window.__brfQtyMax) return; window.__brfQtyMax = true;
  var doc = document, QTY = '.brf-qa__qty, .brf-ucard__qty', IN = '.brf-qa__in, .brf-ucard__in';
  function unit(q){
    var card = q.closest('.product-item, .brf-card, .brf-ucard--buy, .brf-ucard') || q.closest('form');
    var sel = card && card.querySelector('select[data-brf-pick]');
    if (sel) return sel.getAttribute('data-u') === 'm' ? 'm' : '';
    var u = card && card.querySelector('.brf-unit');
    return u && /metre/i.test(u.textContent) ? 'm' : '';
  }
  function say(q, max){
    var form = q.closest('form'); if (!form) return;
    var u = unit(q), host = form.parentNode, ib = host && host.querySelector('.brf-qa__inbag'), inBag = ib ? parseInt(ib.getAttribute('data-n'), 10) || 0 : 0;
    var amt = '<b>' + max + (u ? 'm' : '') + '</b>', msg;
    if (inBag) msg = 'You’ve already got ' + inBag + (u ? 'm' : '') + ' in your bag, so ' + amt + ' more is all we can add 🧵';
    else if (u) msg = 'Whoa there! We’ve only got ' + amt + ' of this one, so that’s the most you can add 🧵';
    else msg = 'Whoa there! We’ve only got ' + amt + ' of these, so that’s the most you can add 🧵';
    var b = form.querySelector(':scope > .brf-qmax');
    if (!b) { b = doc.createElement('div'); b.className = 'brf-qmax'; b.setAttribute('role', 'status'); b.setAttribute('aria-live', 'polite'); form.appendChild(b); }
    form.classList.add('brf-qmax-host');
    b.innerHTML = msg;
    var fr = form.getBoundingClientRect(), qr = q.getBoundingClientRect();
    /* not enough room above (a sticky bar or the top of the screen): show it under the form instead */
    b.classList.toggle('is-below', fr.top - b.offsetHeight - 10 < 130);
    b.style.setProperty('--brf-qmax-x', Math.max(14, Math.min(qr.left - fr.left + qr.width / 2, fr.width - 14)) + 'px');
    requestAnimationFrame(function(){ b.classList.add('is-on'); });
    clearTimeout(b.__t); b.__t = setTimeout(function(){ b.classList.remove('is-on'); }, Math.max(4500, window.brfReadMs(b) - 1500));
    q.classList.remove('brf-qshake'); void q.offsetWidth; q.classList.add('brf-qshake');
    clearTimeout(q.__t); q.__t = setTimeout(function(){ q.classList.remove('brf-qshake'); }, 600);
    if (navigator.vibrate) try { navigator.vibrate(25); } catch(e){}
  }
  function maxOf(inp){ var m = parseInt(inp.getAttribute('max'), 10); return isNaN(m) ? null : m; }
  /* + at the limit: a disabled + lets the tap fall through to the box (CSS above), a live + is checked after the step runs */
  doc.addEventListener('click', function(e){
    var t = e.target, q = t.closest && t.closest(QTY); if (!q) return;
    var inp = q.querySelector(IN); if (!inp || inp.disabled) return;
    var max = maxOf(inp); if (max == null) return;
    var plus = q.querySelector('[data-d="1"]'); if (!plus) return;
    var onPlus = t.closest('[data-d="1"]');
    if (!onPlus) {
      if (t.closest('button, input')) return;
      var r = plus.getBoundingClientRect(); if (e.clientX < r.left - 2) return;
    }
    var before = parseInt(inp.value, 10) || 1;
    setTimeout(function(){ if (before >= max && (parseInt(inp.value, 10) || 1) >= max) say(q, max); }, 0);
  }, true);
  /* typing a number bigger than we have */
  doc.addEventListener('input', function(e){
    var inp = e.target; if (!inp.matches || !inp.matches(IN)) return;
    var max = maxOf(inp), v = parseInt(inp.value, 10); if (max == null || isNaN(v) || v <= max) return;
    inp.value = max;
    var q = inp.closest(QTY), plus = q && q.querySelector('[data-d="1"]'), minus = q && q.querySelector('[data-d="-1"]');
    if (plus) plus.disabled = true; if (minus) minus.disabled = max <= 1;
    if (q) say(q, max);
  }, true);
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-29/30 (Abid): quick view colour option shows small photo swatches when 20 or fewer colours are in stock
   (the quick view already lists only in-stock colours); more than 20 keeps the dropdown.
   v2 (30 Oct): picking a colour makes the theme re-draw the quick view's option block, so the swatches are rebuilt before
   the next paint (no dropdown flash; the modal keeps data-brf-qvsw (an attribute: the theme resets the modal's class list while re-drawing) so the new dropdown is hidden from the start), and the
   chosen colour's photo is decoded before the switch, so the photo never goes blank. */
(function(){
  if (window.__brfQvSw) return; window.__brfQvSw = 1;
  var doc = document, MAX = 20, cache = {}, data = {};
  function handleOf(m){ try { return JSON.parse(m.querySelector('[data-product-json]').textContent).product.handle; } catch (e) { return ''; } }
  function product(h){
    return cache[h] || (cache[h] = fetch('/products/' + h + '.js', {credentials: 'same-origin'}).then(function(r){ return r.json(); }).then(function(p){ data[h] = p; return p; }));
  }
  function paint(wrap, p){
    var img = {}; p.variants.forEach(function(v){ if (v.featured_image && !img[v.option1]) img[v.option1] = v.featured_image.src; });
    [].forEach.call(wrap.children, function(b){ var s = img[b.title]; if (s && !b.style.backgroundImage) b.style.backgroundImage = 'url("' + s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=80")'; });
  }
  /* decode the photo of the colour about to be shown, then switch (max 700ms), so the old photo stays until the new one is ready */
  function ready(m, h, value, go){
    var p = data[h], v = p && p.variants.filter(function(x){ return String(x.option1) === value; })[0], md = v && v.featured_media;
    var it = md && m.querySelector('.product-gallery__carousel-item[data-media-id="' + md.id + '"]'), img = it && it.querySelector('img');
    if (!img || (img.complete && img.naturalWidth)) return go();
    var done = 0, fin = function(){ if (!done) { done = 1; go(); } };
    img.loading = 'eager'; (img.decode ? img.decode() : Promise.reject()).then(fin, fin); setTimeout(fin, 700);
  }
  function build(m){
    var h = handleOf(m); if (!h) return;
    if (m.__brfQvH !== h) { m.__brfQvH = h; m.removeAttribute('data-brf-qvsw'); }
    var opt = m.querySelector('.product-form__option[data-selector-type="select"]');
    if (!opt || opt.querySelector('.brf-qvsw')) return;
    var lab = opt.querySelector('.product-form__option-name'), sel = opt.querySelector('select.product-form__single-selector');
    if (!sel || !/colou?r/i.test(lab ? lab.textContent : '')) return;
    var os = [].filter.call(sel.options, function(o){ return !o.disabled; });
    if (os.length < 2 || os.length > MAX) return;   /* (never cleared here: mid re-draw the new list can look empty) */
    var wrap = doc.createElement('div'); wrap.className = 'brf-qvsw'; wrap.setAttribute('role', 'radiogroup'); wrap.setAttribute('aria-label', 'Colour');
    os.forEach(function(o){
      var b = doc.createElement('button'), n = o.getAttribute('data-value') || o.textContent.trim(), c = n.toLowerCase().replace(/\s+/g, '');
      b.type = 'button'; b.className = 'brf-qvsw__b'; b.title = n; b.setAttribute('aria-label', n); b.setAttribute('role', 'radio'); b.setAttribute('data-v', o.value);
      if (window.CSS && CSS.supports('color', c)) b.style.backgroundColor = c;
      wrap.appendChild(b);
    });
    function sync(){ [].forEach.call(wrap.children, function(b){ var on = b.getAttribute('data-v') === sel.value; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
    wrap.addEventListener('click', function(e){
      var b = e.target.closest('.brf-qvsw__b'); if (!b || b.getAttribute('data-v') === sel.value) return;
      var v = b.getAttribute('data-v'), name = b.title;
      [].forEach.call(wrap.children, function(x){ x.classList.toggle('is-on', x === b); });   /* the ring moves at once */
      ready(m, h, name, function(){ if (!sel.isConnected) return; sel.value = v; sel.dispatchEvent(new Event('change', {bubbles: true})); });
    });
    sel.addEventListener('change', sync);
    opt.classList.add('brf-qvsw-on'); m.setAttribute('data-brf-qvsw', '1');
    (sel.closest('.select-wrapper') || sel).insertAdjacentElement('afterend', wrap); sync();
    m.style.setProperty('--brf-qvsw-oh', opt.offsetHeight + 'px');   /* keeps the row's height through the next re-draw */
    if (data[h]) paint(wrap, data[h]); else product(h).then(function(p){ paint(wrap, p); }).catch(function(){ delete cache[h]; });
  }
  function scan(){ [].forEach.call(doc.querySelectorAll('.modal[id^="modal-quick-view"][aria-hidden="false"]'), build); }
  /* no debounce: a mutation observer runs before the browser paints, so a re-drawn option block gets its swatches straight back */
  function go(){ scan(); new MutationObserver(scan).observe(doc.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden']}); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();   /* this file loads in <head>, before <body> exists */
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-29 (Abid): card colour dots and the colour picker stay in step.
   The picker only lists colours in stock. A sold-out colour's dot is shown faded with a fine line, but can still be tapped
   to see that colour: the photo swaps (theme/card-pick code), the picker shows "<Colour> · Sold out", and Add to bag and
   the qty are locked, so a sold-out colour can never be added. Picking an in-stock dot or picker option undoes all of it. */
(function(){
  if (window.__brfDotSync) return; window.__brfDotSync = 1;
  var doc = document, t = 0;
  function realOpts(sel){ return [].filter.call(sel.options, function(o){ return !o.hasAttribute('data-brf-out'); }); }
  function inStock(sel, v){ return realOpts(sel).some(function(o){ return ('|' + (o.getAttribute('data-opts') || o.textContent.trim()) + '|').indexOf('|' + v + '|') > -1; }); }
  function parts(card){
    var sel = card.querySelector('select[data-brf-pick]'); if (!sel) return null;
    var fid = sel.getAttribute('data-brf-for'), form = fid ? doc.getElementById(fid) : card.querySelector('form.brf-qa-form');
    return {sel: sel, form: form, pick: sel.closest('.brf-ucard__pick'), dot: [].filter.call(card.querySelectorAll('.color-swatch__radio'), function(r){ return r.checked; })[0]};
  }
  function mark(card){
    var sel = card.querySelector('select[data-brf-pick]'); if (!sel) return;
    [].forEach.call(card.querySelectorAll('.color-swatch__radio'), function(r){
      var out = !inStock(sel, r.value), sw = r.closest('.color-swatch');
      if (sw && sw.classList.contains('brf-dot-out') !== out) sw.classList.toggle('brf-dot-out', out);
      if (r.disabled) r.disabled = false;
      var l = sw && sw.querySelector('.color-swatch__item');
      if (l) { var tt = (l.getAttribute('title') || r.value).replace(/ · sold out$/, ''); if (l.getAttribute('title') !== (out ? tt + ' · sold out' : tt)) l.setAttribute('title', out ? tt + ' · sold out' : tt); }
    });
  }
  /* "Only 4m left" for the option now showing (a dot updates the picker without a change event, so the stock note
     used to keep the previous colour's count); empty for a sold-out colour. Same wording as the card stock note */
  function showLeft(c){
    var el = c.pick && c.pick.querySelector('.brf-ucard__left'); if (!el) return;
    var o = c.sel.options[c.sel.selectedIndex], n = o && !o.hasAttribute('data-brf-out') ? parseInt(o.getAttribute('data-max'), 10) : NaN, u = c.sel.getAttribute('data-u') || '';
    var s = isNaN(n) ? '' : (n <= 5 ? 'Only ' + n + u + ' left' : n + u + ' left');
    if (el.textContent !== s) el.textContent = s;
    el.classList.toggle('is-low', !isNaN(n) && n <= 5); el.classList.toggle('is-ok', !isNaN(n) && n > 5);
  }
  function block(c, name){
    var sel = c.sel, tmp = sel.querySelector('option[data-brf-out]');
    if (!tmp) { tmp = doc.createElement('option'); tmp.setAttribute('data-brf-out', '1'); tmp.value = ''; sel.appendChild(tmp); }
    tmp.setAttribute('data-opts', name); tmp.textContent = name + ' · Sold out';
    if (sel.options[sel.selectedIndex] !== tmp) tmp.selected = true;
    if (c.pick) c.pick.classList.add('brf-pick-out');
    showLeft(c);
    var f = c.form; if (!f) return;
    f.classList.add('brf-qa-out');
    var id = f.querySelector('[name="id"]'); if (id && !id.disabled) { id.setAttribute('data-brf-id', id.value); id.value = ''; id.disabled = true; }
    [].forEach.call(f.querySelectorAll('.brf-qa__step, .brf-qa__in'), function(x){ x.disabled = true; });
    var add = f.querySelector('.brf-qa__add'), lbl = add && add.querySelector('.brf-qa__lbl');
    if (add) add.disabled = true;
    if (lbl && lbl.textContent !== 'Sold out') { lbl.setAttribute('data-brf-lbl', lbl.textContent); lbl.textContent = 'Sold out'; }
  }
  function unblock(c){
    var sel = c.sel, tmp = sel.querySelector('option[data-brf-out]');
    if (tmp) { var was = sel.options[sel.selectedIndex] === tmp; sel.removeChild(tmp); if (was) sel.selectedIndex = -1; }
    if (c.pick) c.pick.classList.remove('brf-pick-out');
    showLeft(c);
    var f = c.form; if (!f || !f.classList.contains('brf-qa-out')) return;
    f.classList.remove('brf-qa-out');
    var o = sel.options[sel.selectedIndex], id = f.querySelector('[name="id"]');
    if (id) { id.disabled = false; id.value = o ? o.value : (id.getAttribute('data-brf-id') || id.value); id.removeAttribute('data-brf-id'); }
    var inp = f.querySelector('.brf-qa__in'), mx = o && parseInt(o.getAttribute('data-max'), 10), n = inp ? (parseInt(inp.value, 10) || 1) : 1;
    if (inp) inp.disabled = false;
    var minus = f.querySelector('.brf-qa__step[data-d="-1"]'), plus = f.querySelector('.brf-qa__step[data-d="1"]');
    if (minus) minus.disabled = n <= 1;
    if (plus) plus.disabled = !isNaN(mx) && n >= mx;
    var add = f.querySelector('.brf-qa__add'), lbl = add && add.querySelector('.brf-qa__lbl');
    if (add && !add.__brfBusy) add.disabled = false;
    if (lbl && lbl.hasAttribute('data-brf-lbl')) { lbl.textContent = lbl.getAttribute('data-brf-lbl'); lbl.removeAttribute('data-brf-lbl'); if (window.brfFitQa) window.brfFitQa(add); }
  }
  /* one place decides the state from what is on screen: the checked dot, else the picker */
  function sync(card){
    var c = parts(card); if (!c) return;
    var sel = c.sel, o = sel.options[sel.selectedIndex];
    if (c.dot && !inStock(sel, c.dot.value) && (!o || o.hasAttribute('data-brf-out'))) block(c, c.dot.value);
    else if (o && o.hasAttribute('data-brf-out')) block(c, o.getAttribute('data-opts'));
    else unblock(c);
  }
  /* runs before the card-pick handler (window, capture): a tapped in-stock dot or picker option first clears the
     sold-out state, so the card-pick code then fills in the right variant, max and photo as usual */
  window.addEventListener('change', function(e){
    var el = e.target; if (!el || !el.matches) return;
    var card = el.closest && el.closest('.product-item'); if (!card) return;
    var c = parts(card); if (!c) return;
    if (el.matches('.color-swatch__radio')) {
      if (inStock(c.sel, el.value)) unblock(c);
      else { var tmp = c.sel.querySelector('option[data-brf-out]'); if (!tmp || !tmp.selected) c.sel.selectedIndex = -1; }
    } else if (el === c.sel) {
      var o = el.options[el.selectedIndex];
      if (o && !o.hasAttribute('data-brf-out')) unblock(c);
      else if (o) { e.stopImmediatePropagation(); }   /* the "· Sold out" line itself: nothing to apply */
    } else return;
    setTimeout(function(){ sync(card); }, 0);
  }, true);
  /* belt and braces: a locked card can never submit */
  doc.addEventListener('submit', function(e){ if (e.target && e.target.classList && e.target.classList.contains('brf-qa-out')) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
  doc.addEventListener('click', function(e){ var b = e.target.closest && e.target.closest('.brf-qa-out .brf-qa__add, .brf-qa-out .brf-qa__step'); if (b) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
  function scan(){ [].forEach.call(doc.querySelectorAll('.product-item'), function(card){ if (card.querySelector('select[data-brf-pick]') && card.querySelector('.color-swatch__radio')) mark(card); }); }
  function go(){ scan(); new MutationObserver(function(){ clearTimeout(t); t = setTimeout(scan, 80); }).observe(doc.body, {childList: true, subtree: true}); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();   /* loads in <head>, before <body> exists */
})();
